module.exports = __webpack_public_path__ + "media/images/pic/testimonials/patti-a57812132a13bb50bed006f069192864.webp";